.d0{aspect-ratio:1/1;}